import TextButton from "@shared/v2/TextButton";
import Button from "@shared/v2/Button";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useFeatureFlags, useIsLever, useIsPlace } from "../reducers/layoutReducer/selectors";
import useActiveProducts from "../Products/hooks/useActiveProducts";
import { ProductFamilyIds } from "../Products/constants";

const OpportunitiesCard = () => {
  const featureFlags = useFeatureFlags();
  const isPlace = useIsPlace();
  const isLever = useIsLever();
  const { activeProducts } = useActiveProducts(ProductFamilyIds.Opportunities);
  const isOpportunitiesActive = isPlace || isLever || activeProducts.length > 0;

  return (
    <ZoomCard
      actions={
        <>
          {isOpportunitiesActive && (
            <TextButton
              className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
              size="medium"
              onClick={() => window.open("/opportunities", "_blank")}
            >
              Launch Opportunities <ArrowUpRightFromSquareSolidV6 />
            </TextButton>
          )}

          {!isOpportunitiesActive && featureFlags.opportunitiesAddonPurchase && (
            <div className="tw-flex tw-gap-[8px]">
              <Button
                size="medium"
                schema="secondary"
                onClick={() => window.location.assign("/opportunities?signup")}
              >
                Purchase
              </Button>
              <TextButton size="medium" onClick={() => window.location.assign("/opportunities")}>
                Learn More
              </TextButton>
            </div>
          )}

          {!isOpportunitiesActive && !featureFlags.opportunitiesAddonPurchase && (
            <div
              className="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-191265610373"
              data-hubspot-wrapper-cta-id="191265610373"
            >
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank" rel="noopener noreferrer">
                <img
                  alt="GET NOTIFIED"
                  loading="lazy"
                  src="https://no-cache.hubspot.com/cta/default/6041126/interactive-191265610373.png"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </a>
            </div>
          )}
        </>
      }
      title="Opportunities"
      onClick={
        isPlace || featureFlags.opportunitiesAddonPurchase
          ? () => window.location.assign("/opportunities")
          : undefined
      }
      onClickText={isOpportunitiesActive ? "Launch" : "Learn More"}
      comingSoon={!isPlace && !featureFlags.opportunitiesAddonPurchase}
      subscribed={isOpportunitiesActive}
      description="Be the first to reach out with extensive prospecting data for Expireds, FSBO’s, and Pre-foreclosure leads."
      imgSrc="/images/bg-card-opportunities.png"
      imgClassName="tw-mx-[12px]"
    />
  );
};

export default OpportunitiesCard;
